import { __assign } from "tslib";
import React, { useEffect } from 'react';
import { PnmacHtmlToNative, PnmacUIButton, PnmacNavigation } from 'pnmac-universal-components';
import { View, Image, Text } from 'react-native';
import styles from '../../styles/styles.js';
import BannerView from '../../v2/BannerView';
var SimplyIOA = function (props) {
  useEffect(function () {
    if (props.open) {
      props.addTracker(2);
    }
  }, [props.open]);
  var modalContent = function () {
    var translations = props.translations,
      addTracker = props.addTracker,
      layout = props.layout,
      matches = props.matches;
    return /*#__PURE__*/React.createElement(View, {
      style: {
        backgroundColor: "white",
        borderRadius: 10,
        padding: 20,
        maxWidth: matches.small ? "100%" : "600px",
        maxHeight: "300px"
      }
    }, /*#__PURE__*/React.createElement(View, {
      style: {
        paddingVertical: 10
      }
    }, /*#__PURE__*/React.createElement(PnmacHtmlToNative, {
      value: translations === null || translations === void 0 ? void 0 : translations.SimplyIOAInterstitialTitle
    })), /*#__PURE__*/React.createElement(BannerView, {
      style: {
        paddingTop: 10
      },
      type: 'warning'
    }, !layout.mobile ? /*#__PURE__*/React.createElement(View, {
      style: {
        display: "flex",
        flexDirection: "row",
        justifyContent: "flex-start"
      }
    }, /*#__PURE__*/React.createElement(Image, {
      source: require("../../assets/warning.svg"),
      style: {
        marginRight: 10,
        width: 35,
        height: 35
      }
    }), " ", /*#__PURE__*/React.createElement(PnmacHtmlToNative, {
      value: translations === null || translations === void 0 ? void 0 : translations.SimplyIOAinterstitialpage
    })) : /*#__PURE__*/React.createElement(View, {
      style: {
        display: "flex",
        flexDirection: "row",
        justifyContent: "flex-start",
        marginRight: 10
      }
    }, /*#__PURE__*/React.createElement(Image, {
      style: {
        width: 30,
        height: 30,
        marginRight: 10,
        alignSelf: 'center'
      },
      source: require("../../assets/warning.png")
    }), /*#__PURE__*/React.createElement(PnmacHtmlToNative, {
      value: translations === null || translations === void 0 ? void 0 : translations.SimplyIOAinterstitialpage
    })), /*#__PURE__*/React.createElement(View, null, /*#__PURE__*/React.createElement(PnmacHtmlToNative, {
      value: translations === null || translations === void 0 ? void 0 : translations.SimplyIOAinterstitialtimeout
    }))), /*#__PURE__*/React.createElement(View, {
      style: {
        display: "flex",
        flexDirection: matches.small ? "column" : "row",
        justifyContent: "space-between"
      }
    }, /*#__PURE__*/React.createElement(View, null, /*#__PURE__*/React.createElement(PnmacUIButton, {
      mode: "outlined",
      style: __assign(__assign({}, styles.accountSettings.button), {
        marginTop: 20
      }),
      labelStyle: {
        color: "#003087"
      },
      onPress: function () {
        addTracker(3);
        props.modalClose();
      }
    }, translations === null || translations === void 0 ? void 0 : translations.SimplyIOAInterstitialCancel)), /*#__PURE__*/React.createElement(View, null, /*#__PURE__*/React.createElement(PnmacUIButton, {
      mode: "contained",
      style: __assign(__assign({}, styles.accountSettings.button), {
        marginTop: 20
      }),
      labelStyle: {
        color: "#003087"
      },
      onPress: function () {
        var _a;
        addTracker(4);
        PnmacNavigation(__assign({
          action: (_a = props === null || props === void 0 ? void 0 : props.simplyIOAData) === null || _a === void 0 ? void 0 : _a.quoteUrl,
          wind: true,
          target: "_blank"
        }, props));
      }
    }, translations === null || translations === void 0 ? void 0 : translations.SimplyIOAInterstitialContinue))));
  };
  return /*#__PURE__*/React.createElement(React.Fragment, null, modalContent());
};
export default /*#__PURE__*/React.forwardRef(SimplyIOA);